import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormControlLabel, Switch } from '@material-ui/core';
import { fontFamilies } from '../../theme/text';

const SwitchLabel = withStyles({
  label: {
    textTransform: 'uppercase',
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    color: '#8a8a8a',
    marginTop: 15
  }
})(FormControlLabel);

const GreenSwitch = withStyles({
  root: {
    padding: 7,
    marginTop: 15
  },
  switchBase: {
    color: '#ffffff',
    fontWeight: 500,
    '&$checked': {
      color: '#ffffff'
    },
    '&$checked + $track': {
      backgroundColor: '#0e834a',
      opacity: 1
    },
    disabled: {
      opacity: 0.5
    }
  },
  checked: {},
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#8a8a8a',
    opacity: 1
  },
  disabled: {
    opacity: 0.5
  }
})(Switch);

interface Props {
  id: string;
  value: any;
  label: string;
  handleChange: any;
  disabled?: boolean;
}

const SwitchBox = ({ id, value, label, handleChange, disabled }: Props) => {
  return (
    <SwitchLabel
      control={<GreenSwitch id={id} checked={value} onChange={handleChange} disabled={disabled} />}
      label={label}
    />
  );
};
export default SwitchBox;
